import { Grid } from '@mui/material'
import React from 'react'
import Heading from './Heading'
import FullName from './FullName'
import Email from './Email'
import Phone from './Phone'
import DropDown from './DropDown'
import LongText from './LongText'
import DatePickers from './DatePicker'

const ServiceCancellationRequestForm = () => {


    const serviceType =[
        'خدمات اینترنتی',
        'خدمات تلفن',
        'تلویزیون کابلی',
        'سرویس استریم',
        'دیگر',
    ]

    return (
        <Grid p={{ xs: '40px 13px', md: '40px 52px' }} bgcolor={'white'} borderRadius={'20px'} width={'100%'} maxWidth={'700px'} boxShadow={'0 4px 4px rgba(87,100,126,.21)'} m={{ xs: '72px 0px', md: '72px 42px' }}>
            <Heading header={'فرم درخواست لغو سرویس'} subHeader={'لطفا برای درخواست لغو سرویس خود، این فرم را پر کنید.'} />
            <Grid className='states' display={'flex'} flexDirection={'column'} alignItems={'flex-start'} justifyContent={'flex-start'}>
                <FullName header={'نام و نام خانوادگی'} />
                <Email header={'آدرس ایمیل'}/>
                <Phone header={'شماره تلفن'}/>
                <DropDown header={'سرویس برای لغو'} options={serviceType} />
                <LongText header={'دلیل لغو'} />
                <DatePickers header={'تاریخ لغو ترجیحی'} />
            </Grid>
        </Grid>
    )
}

export default ServiceCancellationRequestForm
